import { render, staticRenderFns } from "./DateInput.component.vue?vue&type=template&id=fb86f7fa&scoped=true&"
import script from "./DateInput.component.vue?vue&type=script&lang=js&"
export * from "./DateInput.component.vue?vue&type=script&lang=js&"
import style0 from "./DateInput.component.vue?vue&type=style&index=0&id=fb86f7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb86f7fa",
  null
  
)

export default component.exports